"use strict";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(function () {
	function r(e, n, t) {
		function o(i, f) {
			if (!n[i]) {
				if (!e[i]) {
					var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
				}var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
					var n = e[i][1][r];return o(n || r);
				}, p, p.exports, r, e, n, t);
			}return n[i].exports;
		}for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
			o(t[i]);
		}return o;
	}return r;
})()({ 1: [function (require, module, exports) {
		"use strict";

		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				$('.wpcf7-list-item').append('<span class="acceptance__mask"></span>');

				$('.acceptance__mask').on('click', function () {
					$('.form__acceptance').trigger('click');
					$('.acceptance__mask').toggleClass('acceptance__mask--active');
				});

				$('.wpcf7-list-item-label').on('click', function () {
					$('.acceptance__mask').toggleClass('acceptance__mask--active');
				});
			}
		};
	}, {}], 2: [function (require, module, exports) {
		"use strict";

		var Global = require('./global'); // require Global only if you need it
		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {}
		};
	}, { "./global": 5 }], 3: [function (require, module, exports) {
		"use strict";

		var Global = require('./global'); // require Global only if you need it
		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {

				$(document).ready(function () {});
			}
		};
	}, { "./global": 5 }], 4: [function (require, module, exports) {
		"use strict";

		var Global = require('./global'); // require Global only if you need it
		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				maincanvas: $('#main-canvas')
			},
			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				// get dom and strings
				var $dom = this.$dom;

				if ($dom.maincanvas.length > 0) {
					(function () {
						window.Game = {};

						(function () {
							function Sprite(settings) {
								// SPAWN POINTS            
								this.staticDebug = false;
								this.offscreen = true;
								this.image = settings.image;
								this.width = settings.image ? settings.image.width : 5;
								this.height = settings.image ? settings.image.height : 5;
								if (settings.x) {
									this.x = settings.x;
								} else {
									this.x = 500;
								}
								this.scale = settings.scale ? settings.scale : 1;
								this.angle = settings.angle || 0;
								this.opacity = 1;
								this.fadeinarea = settings.fadeinarea ? settings.fadeinarea : 300;
								this.fadeoutarea = settings.fadeoutarea ? settings.fadeoutarea : 300;

								this.vOffset = settings.vOffset || 0;

								this.cf0 = this.vOffset * 63 + 0;
								this.cf1 = this.vOffset * -0.03615036 + 0.7163616;
								this.cf2 = this.vOffset * 0.00000479029 + 0.0004735437;
								this.cf3 = this.vOffset * 0.00000000616958 + 0.0000001165965;

								// move speed in pixels per second
								this.speed = settings.speed || -5;
								this.rotationSpeed = settings.rotationSpeed ? settings.rotationSpeed : .01;
							}

							Sprite.prototype.update = function (worldWidth, worldHeight) {
								// if (this.staticDebug === false) {
								// parameter step is the time between frames ( in seconds )
								var offset = this.offscreen ? this.width / 2 : 0;

								// apply movement and rotation
								this.x += this.speed;
								this.angle += this.rotationSpeed;

								// loop back to the start
								if (this.x > worldWidth + offset) {
									this.x = -offset;
								}

								if (this.x < 0 - offset) {
									this.x = worldWidth + offset;
								}

								// fandein and out
								if (this.x < this.fadeinarea) {
									// fade in                
									this.opacity = 0 + (this.x + offset) * (1 - 0) / (this.fadeinarea + offset);
								} else {
									if (this.x > worldWidth - this.fadeoutarea) {
										// fading out
										this.opacity = 1 - (0 + (this.x - (worldWidth - this.fadeoutarea)) * (1 - 0) / (worldWidth + offset - (worldWidth - this.fadeoutarea)));
									} else {
										this.opacity = 1;
									}
								}

								this.y = +this.cf0 + this.cf1 * this.x - this.cf2 * Math.pow(this.x, 2) + this.cf3 * Math.pow(this.x, 3);

								//     this.staticDebug = true;
								// }
							};

							Sprite.prototype.draw = function (context) {
								// draw a simple rectangle shape as our Sprite model
								context.save();

								context.globalAlpha = this.opacity;
								context.translate(this.x, this.y);
								context.rotate(this.angle);
								context.translate(-this.x, -this.y);
								context.drawImage(this.image, this.x - this.width / 2, this.y - this.height / 2, this.width * this.scale, this.height * this.scale);
								context.globalAlpha = 1;

								// context.fillRect(this.x, this.y, 5, 5);
								context.restore();
							};

							// add "class" Sprite to our Game object
							Game.Sprite = Sprite;
						})();

						function init() {
							// prepaire our game canvas
							var canvas = document.getElementById("main-canvas"),
							    context = canvas.getContext("2d"),
							    cWidth = context.canvas.width,
							    cHeight = context.canvas.height;

							// game settings:	
							var fruitSettings = [];

							for (var i = 0; i < Game.assets.length; i++) {
								// let tesxt = canvas_globals.start_pos[i].vOffset;
								var spriteSetting = {
									image: Game.assets[i],
									x: canvas_globals.start_pos[i].x,
									vOffset: canvas_globals.start_pos[i].vOffset
								};

								fruitSettings.push(spriteSetting);
							}

							// instantiate fruits
							var fruits = [];

							for (var _i = 0; _i < fruitSettings.length; _i++) {
								var fruit = new Game.Sprite(fruitSettings[_i]);
								fruits.push(fruit);
							}

							// Game update function
							var update = function update() {
								for (var _i2 = 0; _i2 < fruits.length; _i2++) {
									fruits[_i2].update(cWidth, cHeight);
								}
							};

							// Game draw function
							var draw = function draw() {
								// clear the entire canvas
								context.clearRect(0, 0, canvas.width, canvas.height);

								// main layer 
								for (var _i3 = 0; _i3 < fruits.length; _i3++) {
									fruits[_i3].draw(context);
								}
							};

							// Game Loop
							var gameLoop = function gameLoop() {
								update();
								draw();
								window.requestAnimationFrame(gameLoop);
							};

							gameLoop();
						}

						Game.init = init;
					})();

					(function () {
						function load_assets() {
							var imageCount = 0; // number of loaded images

							// iterate each image URL, create, load, and add it to the images array
							imageURL.forEach(function (img) {
								var image = new Image();
								if (img) {
									image.src = img;
									assets.push(image);
								} else {
									imageCount += 1;
								}

								image.onload = function () {
									imageCount += 1;
									// have all loaded????
									if (imageCount === imageURL.length) {
										Game.init(0);
									}
								};
							});
						}

						// adding assets from localized script
						var imageURL = canvas_globals.imgUrls;

						var assets = [];

						Game.assets = assets;
						Game.load_assets = load_assets;
					})();

					Game.load_assets();

					// console.log();

				}
			}
		};
	}, { "./global": 5 }], 5: [function (require, module, exports) {
		"use strict";

		module.exports = {
			$dom: {
				window: $(window),
				body: $('body')
			},

			vars: {
				windowWidth: window.innerWidth
			},

			functions: {
				escKey: function escKey(callback) {
					$(document).on('keyup', function (e) {
						if (e.keyCode === 27) {
							callback();
						}
					});
				},

				clickOutsideContainer: function clickOutsideContainer(selector, container, closeBtn, callback) {
					selector.on('mouseup', function (e) {
						e.preventDefault();
						if (!container.is(e.target) && container.has(e.target).length === 0 && !closeBtn.is(e.target)) {
							callback();
						}
					});
				}
			}
		};
	}, {}], 6: [function (require, module, exports) {
		"use strict";

		var Global = require('./global'); // require Global only if you need it
		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {

				$('.form__input').focus(function () {
					$(this).parent().parent().find('.form__label').fadeOut('slow');
				});
				$('.form__input').blur(function () {
					if ($(this).val() <= 1) {
						$(this).parent().parent().find('.form__label').fadeIn('slow');
					}
				});
			}
		};
	}, { "./global": 5 }], 7: [function (require, module, exports) {
		"use strict";

		var Global = require('./global');
		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				menuBtn: $('.js-menu-btn'),
				menuNav: $('.js-main-nav'),
				menuHasSub: $('.menu-item-has-children')
			},

			classes: {
				open: 'open',
				openMenu: 'menu-open'
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				// get dom and strings
				var $dom = this.$dom;
				var classes = this.classes;

				// functions
				function closeNav() {
					$dom.menuBtn.removeClass(classes.open);
					$dom.menuNav.removeClass(classes.open);
					Global.$dom.body.removeClass(classes.openMenu);
				}

				if (Global.$dom.window.width() < 901) {
					$dom.menuHasSub.each(function (i, el) {
						$(el).append('<span class="sub-icon font-arrow-down" data-open-sub></span>');
					});
				}

				// bind events
				$dom.menuBtn.on('click', function (e) {
					e.preventDefault();
					$dom.menuBtn.toggleClass(classes.open);
					$dom.menuNav.toggleClass(classes.open);
					Global.$dom.body.toggleClass(classes.openMenu);
				});

				$dom.menuNav.on('click', '[data-open-sub]', function () {
					if (Global.$dom.window.width() < 901) {
						$(this).siblings('.sub-menu').slideToggle();
					}
				});

				Global.functions.clickOutsideContainer($dom.menuNav, $dom.menuNav.children('ul'), $dom.menuBtn, closeNav);

				Global.functions.escKey(closeNav);
			}
		};
	}, { "./global": 5 }], 8: [function (require, module, exports) {
		"use strict";

		var Global = require('./global'); // require Global only if you need it
		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {

				$(document).ready(function () {
					$('.preloader').delay(2000).fadeOut('slow');
				});
			}
		};
	}, { "./global": 5 }], 9: [function (require, module, exports) {
		"use strict";

		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				slider: $('.js-slider'),
				testimonials: $('.testimonials__slider'),
				heroslider: $('.hero__slider'),
				heroFull: $('.hero-slider__full-slider'),
				doubleSlider: $('.hero__double-slider'),
				heroFullNav: $('.hero-slider__full-slider--nav')
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				var _$dom$heroFullNav$sli;

				// get dom and strings
				var $dom = this.$dom;

				// slider
				$dom.slider.slick({
					infinite: true,
					slidesToShow: 4,
					slidesToScroll: 1,
					speed: 1000,
					arrows: false,
					responsive: [{
						breakpoint: 991,
						settings: {
							slidesToShow: 3
						}
					}, {
						breakpoint: 767,
						settings: {
							slidesToShow: 2
						}
					}]
				});

				$dom.testimonials.slick({
					infinite: true,
					autoplay: true,
					speed: 1000,
					dots: true,
					arrows: false,
					fade: true,
					cssEase: 'linear'
				});

				$dom.heroslider.slick({
					infinite: true,
					autoplay: true,
					slidesToShow: 1,
					slidesToScroll: 1,
					speed: 1000,
					autoplaySpeed: 3000,
					dots: true,
					arrows: false
				});

				$dom.heroFull.slick({
					infinite: true,
					autoplay: true,
					slidesToShow: 1,
					slidesToScroll: 1,
					speed: 1000,
					autoplaySpeed: 3000,
					dots: false,
					arrows: false
				});

				$dom.heroFullNav.slick((_$dom$heroFullNav$sli = {
					infinite: true,
					autoplay: true
				}, _defineProperty(_$dom$heroFullNav$sli, "autoplay", true), _defineProperty(_$dom$heroFullNav$sli, "slidesToShow", 1), _defineProperty(_$dom$heroFullNav$sli, "slidesToScroll", 1), _defineProperty(_$dom$heroFullNav$sli, "autoplaySpeed", 3000), _defineProperty(_$dom$heroFullNav$sli, "dots", false), _defineProperty(_$dom$heroFullNav$sli, "arrows", false), _defineProperty(_$dom$heroFullNav$sli, "pauseOnHover", false), _$dom$heroFullNav$sli));

				$dom.doubleSlider.slick({
					infinite: true,
					autoplay: true,
					slidesToShow: 1,
					slidesToScroll: 1,
					speed: 1000,
					autoplaySpeed: 3000,
					// asNavFor: $dom.heroFullNav,
					adaptiveHeight: true,
					dots: true,
					arrows: false,
					fade: true,
					cssEase: 'linear',
					pauseOnHover: false
				});

				setTimeout(function () {
					$dom.testimonials.removeClass('h-hidden');
					$dom.heroslider.removeClass('h-hidden');
					$dom.heroFull.removeClass('h-hidden');
					$dom.heroFullNav.removeClass('h-hidden');
					$dom.doubleSlider.removeClass('h-hidden');
				}, 300);
			}
		};
	}, {}], 10: [function (require, module, exports) {
		jQuery(function ($) {
			// Site Menu
			var menu = require('./_site/menu');
			menu.init();

			// Slick Slider
			var sliders = require('./_site/sliders');
			sliders.init();

			// Form Acceptance
			var acceptance = require('./_site/acceptance');
			acceptance.init();

			// Preloader
			var preloader = require('./_site/preloader');
			preloader.init();

			// Form Inputs
			var inputs = require('./_site/inputs');
			inputs.init();

			// Animations
			var anim = require('./_site/animations');
			anim.init();

			// Animations
			var animFruits = require('./_site/animateFruits');
			animFruits.init();

			// Canvas
			var canvasAnim = require('./_site/canvasAnim');
			canvasAnim.init();
		});
	}, { "./_site/acceptance": 1, "./_site/animateFruits": 2, "./_site/animations": 3, "./_site/canvasAnim": 4, "./_site/inputs": 6, "./_site/menu": 7, "./_site/preloader": 8, "./_site/sliders": 9 }] }, {}, [10]);